import { createFileRoute } from '@tanstack/react-router';

import { courtside } from '@/api/sideline';
import { SidelineMonitorPage } from '@/components/sideline/SidelineMonitorPage';

function Page() {
  return <SidelineMonitorPage api={courtside} sport="basketball" />;
}

export const Route = createFileRoute('/custom/courtside-monitor')({
  component: Page
});
